import { formatRemovedCcRelationMessage } from "@wakeloop/space";

export function getRemovedCcCliInputMessage(
  argv: readonly string[]
): string | null {
  return argv.some((arg) => arg === "--cc" || arg.startsWith("--cc="))
    ? formatRemovedCcRelationMessage("--reference")
    : null;
}
